import localForage from 'localforage'

export default {
  install: app => {
    localForage.config({
      name: 'crms-config',
      driver: [
        localForage.INDEXEDDB,
        localForage.LOCALSTORAGE
      ]
    })

    const areas = localForage.createInstance({
      name: 'crms-storage',
      storeName: 'areas'
    })

    const regions = localForage.createInstance({
      name: 'crms-storage',
      storeName: 'regions'
    })

    const provinces = localForage.createInstance({
      name: 'crms-storage',
      storeName: 'provinces'
    })

    const municipalities = localForage.createInstance({
      name: 'crms-storage',
      storeName: 'municipalities'
    })

    const barangays = localForage.createInstance({
      name: 'crms-storage',
      storeName: 'barangays'
    })

    app.prototype.$forage = {
      localForage,
      areas,
      regions,
      provinces,
      municipalities,
      barangays
    }
  }
}
